export default __webpack_public_path__ + "resources/icons/n0-a3df.png";